<app-leads-popup #leadsPopupRef [isFromService]="true" [isFromServiceOrder]="true" [soId]="dialogData.soId" [soldToBp]="dialogData.soldToBp" (openIscBpLookup)="onOpenIscBpLookup()"></app-leads-popup>

@if (showIscBpLookup) {
<app-config-advanced-search
 
  [company]="company"
  [serviceDepartment]="serviceDepartment"
  (onClose)="onCloseSearchForCustomer($event)"
></app-config-advanced-search>
}
